
import React from "react";


import { connect } from "react-redux";

import history from "../../auth/history";
// import './Subtransaction.css';



class TransferDetails extends React.Component{
    constructor(props){
        super(props);
        this.state={
			phoneNo: this.props.phone,
			password:'',
			otpRef:'',
			message:''
		}
    }

	

  

    componentDidMount(){


       
	}
	componentWillUnmount(){
    }




    

    render(){

    return(
                          
                                <div class="col-12 col-sm-6">												
									<div class="tnsfrdetail">
										<div class="txnhead">Transfer Details</div>
											<div class="odramt">
											<p>Transfer Amount <span>₹ {this.props.amount}</span></p>
											<p>Commission <span>₹ {this.props.surcharge}</span></p>
											</div>
											<div class="ttlamt">
											<p>Total Amount <span>₹ { this.props.totalAmount}</span></p>
											</div>
										</div>												
									</div>

);
      } 
}

const mapStateToProps = (
	{ errorMessageReduce:{errorMessage,loginErrorMessage},
	 miscReduce:{phone}
	,responseReduce:{}}
	) => ({
		errorMessage,loginErrorMessage,phone 
});

export default connect(mapStateToProps, null)(TransferDetails);